class SectionShopTheLook extends HTMLElement {
  constructor () {
    super()

    this.initialise()
  }

  async initialise () {
    await this.sleepUntil(() => document.querySelector('.evm-recommended-products > div'))

    this.renderSection()
  }

  async sleepUntil (condition, duration = 250) {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (condition()) {
          clearInterval(interval)
          resolve()
        }
      }, duration)
    })
  }

  renderSection () {
    this.removeAttribute('aria-hidden')
  }
}

customElements.define('section-shop-the-look', SectionShopTheLook)
